<template>
  <v-container fluid class="container d-flex flex-column">
    <div class="d-flex align-center">
      <v-text-field v-model="searchWord" class="flex-1-1" density="compact" prepend-inner-icon="mdi-magnify" hide-details></v-text-field>
      <v-btn class="ml-4" variant="flat" @click.prevent="onPartner(null)">
        가맹점 등록
      </v-btn>
    </div>
    <v-data-table-virtual
        class="partner-list flex-0-1 mt-4 rounded"
        density="compact"
        :headers="[{
          title: '가맹점', align: 'start', key: 'name',
        }, {
          title: '계정', align: 'start', key: 'account',
        }, {
          title: '장치', align: 'start', key: 'description',
        }, {
          title: '등록일', align: 'start', key: 'createdAt',
        }]"
        :items="filteredItems"
    >
      <template v-slot:headers="{ columns, isSorted, getSortIcon, toggleSort }">
        <tr>
          <template v-for="column in columns" :key="column.key">
            <td>
              <span class="mr-2 cursor-pointer text-subtitle-2" @click="() => toggleSort(column)">{{ column.title }}</span>
              <template v-if="isSorted(column)">
                <v-icon size="xsmall" :icon="getSortIcon(column)"></v-icon>
              </template>
            </td>
          </template>
        </tr>
      </template>
      <template v-slot:item="{ item }">
        <tr
          :class="{'selected-row': dialog.partner.id === item.raw.id}"
          @click.stop="onPartner(item.raw)"
        >
          <td class="text-body-2">{{ item.columns.name }}</td>
          <td class="text-body-2">{{ item.columns.account }}</td>
          <td class="text-body-2">{{ item.columns.description }}</td>
          <td class="text-body-2">{{ item.columns.createdAt }}</td>
        </tr>
      </template>
    </v-data-table-virtual>
  </v-container>
  <v-dialog class="dialog partner-dialog" v-model="dialog.partner.isOpened"
            @update:model-value="dialog.partner.onClose">
    <v-card>
      <v-toolbar color="primary">
        <v-toolbar-title>
          <span class="text-h5">{{ dialog.partner.id ? '가맹점 수정' : '가맹점 등록' }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog.partner.onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-item>
        <div class="d-flex flex-column flex-1-0" style="position: relative;">
            <span
                class="mt-2 pl-1 pr-1 text-subtitle-2 text-grey-darken-2 bg-grey-lighten-4"
                style="position: absolute;left: 16px;line-height: 16px;"
            >
              기본정보
            </span>
          <div class="mt-4 pa-4 flex-1-0" style="border: 1px solid #e0e0e0;border-radius: 5px">
            <v-row dense class="d-flex flex-wrap">
              <v-col cols="12">
                <v-text-field v-model="dialog.partner.name" density="compact" placeholder="*가맹점" hide-details></v-text-field>
              </v-col>
              <v-col key="create-account" cols="12" v-if="!dialog.partner.id">
                <v-text-field v-model="dialog.partner.account" density="compact" placeholder="*계정" hide-details></v-text-field>
              </v-col>
              <v-col key="save-account" cols="12" v-else>
                <v-text-field readonly v-model="dialog.partner.account" density="compact" placeholder="*계정" hide-details></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="dialog.partner.password" density="compact" placeholder="비밀번호" type="password" hide-details></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="dialog.partner.repassword" density="compact" placeholder="비밀번호 확인" type="password" hide-details></v-text-field>
              </v-col>
              <!--                  <v-col cols="12">-->
              <!--                    <v-text-field v-model="dialog.partner.repr" density="compact" placeholder="대표" hide-details></v-text-field>-->
              <!--                  </v-col>-->
              <!--                  <v-col cols="12">-->
              <!--                    <v-checkbox :value="dialog.partner.active" label="사용" hide-details></v-checkbox>-->
              <!--                  </v-col>-->
            </v-row>
          </div>
        </div>
        <div class="d-flex flex-column flex-1-0" style="position: relative;" v-if="!dialog.partner.admin">
            <span
                class="mt-2 pl-1 pr-1 text-subtitle-2 text-grey-darken-2 bg-grey-lighten-4"
                style="position: absolute;left: 16px;line-height: 16px;"
            >
              장치정보
            </span>
          <div class="mt-4 pa-4 flex-1-0" style="border: 1px solid #e0e0e0;border-radius: 5px">
            <v-chip
                class="ma-1 flex-0-0" color="primary"
                @click="() => onDeleteDevice(item)"
                v-for="item in dialog.partner.devices"
            >
              {{ item.name }}
              <template v-slot:append v-if="item.id">
                <v-icon class="ml-1" size="x-small">mdi-close</v-icon>
              </template>
            </v-chip>
            <v-chip class="ma-1 flex-0-0" :loading="true" @click="onAddDevices">
              장치추가
            </v-chip>
          </div>
        </div>
        <div class="d-flex flex-column flex-1-0" style="position: relative;" v-if="!dialog.partner.admin">
            <span
                class="mt-2 pl-1 pr-1 text-subtitle-2 text-grey-darken-2 bg-grey-lighten-4"
                style="position: absolute;left: 16px;line-height: 16px;"
            >
              텔레그램
            </span>
          <div
              class="d-flex mt-4 pa-4 flex-1-0" style="border: 1px solid #e0e0e0;border-radius: 5px"
              v-if="dialog.partner.pendingTelegramChatId === INVALID_TELEGRAM_CHAT_ID"
          >
            <div class="flex-1-1 align-self-center text-body-2">
              Chat ID: {{ dialog.partner.telegramChatId || '등록되지 않음.' }}
            </div>
            <v-btn
                class="ml-2 pa-0 text-body-2"
                max-height="28"
                density="default" variant="tonal"
                @click="dialog.partner.pendingTelegramChatId = dialog.partner.telegramChatId || null"
            >
              {{ dialog.partner.telegramChatId ? '수정' : '등록' }}
            </v-btn>
          </div>
          <div class="d-flex mt-4 pa-4 flex-1-0" style="border: 1px solid #e0e0e0;border-radius: 5px" v-else>
            <div class="flex-1-1 align-self-center text-body-2">
              <v-text-field
                  class="d-none"
                  variant="outlined"
                  dense
                  hide-details
                  :items="[{name: 'name1', value: 'value1'}, {name: 'name2', value: 'value2'}]"
                  item-title="name"
                  item-value="value"
              ></v-text-field>
              <v-combobox
                  v-model="dialog.partner.pendingTelegramChatId"
                  variant="outlined"
                  hide-details
                  :items="appStore.telegramChatIds"
                  item-title="display"
                  item-value="id"
                  @keyup.enter="onChangeTelegramChatId"
              ></v-combobox>
            </div>
            <v-btn
                class="ml-2 pa-0 text-body-2"
                max-height="28"
                density="default"
                variant="tonal"
                @click="onChangeTelegramChatId"
            >
              확인
            </v-btn>
          </div>
        </div>
      </v-card-item>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            variant="tonal"
            :disabled="dialog.partner.pendingTelegramChatId !== INVALID_TELEGRAM_CHAT_ID"
            @click="dialog.partner.onSave"
        >
          {{ dialog.partner.id ? '수정' : '등록' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog class="dialog device-dialog" v-model="dialog.device.isOpened" @update:model-value="dialog.device.onCancel">
    <v-card>
      <v-toolbar color="primary">
        <v-toolbar-title>
          <span class="text-h5">
            장치 추가
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog.device.onCancel && dialog.device.onCancel()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-text-field class="flex-0-0" v-model="dialog.device.searchWord" variant="filled" hide-details prepend-inner-icon="mdi-magnify"></v-text-field>
      <v-list class="device-list">
        <v-list-item :class="{
            'selected-row': dialog.device.selected.includes(device.id)
          }" @click="() => onDevice(device)" v-for="device in filteredDevices">
          {{ device.name }}
        </v-list-item>
        <div class="d-flex justify-center align-center" v-if="0 === filteredDevices.length">
          등록된 장치 없음.
        </div>
      </v-list>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn variant="tonal" @click="dialog.device.onOk && dialog.device.onOk()">확인</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import {inject, onMounted, reactive, ref, toRaw, computed, watch} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {useAppStore} from "@/stores/app";
import {useSessionStore} from "@/stores/session";
import dayjs from "dayjs";

const INVALID_TELEGRAM_CHAT_ID = '';

const axios = inject('axios');

const route = useRoute();
const router = useRouter();
const appStore = useAppStore();
const sessionStore = useSessionStore();

const searchWord = ref('');

const content = reactive({
  items: [],
  devices: [],
});

const loading = reactive({
  addDevice: false,
});

const dialog = reactive({
  partner: {
    isOpened: false,
    name,
    account: '',
    password: '',
    repassword: '',
    repr: '',
    telegramChatId: '',
    pendingTelegramChatId: INVALID_TELEGRAM_CHAT_ID,
    devices: [],
  },
  device: {
    isOpened: false,
    searchWord: '',
    selected: [],
    onOk: null,
    onCancel: null,
  },
});

const filteredItems = computed(() =>
    appStore.users
        .filter(({name}) => {
          const _searchWord = searchWord.value.trim().toUpperCase();
          if (!_searchWord) return true;

          const uppercase = name && name.trim().toUpperCase();
          return uppercase.includes(_searchWord);
        })
        .map(item => ({
          ...item,
          description: (() => {
            if (!item.devices || 0 === item.devices.length)
              return '등록된 장치 없음.'
            return item.devices.map(({name}) => name).join(', ')
            // const [device, ...rest] = item.devices;
            // return 0 < rest.length ? `${device.name} 외 ${rest.length}` : device.name;
          })(),
          createdAt: item.createdAt && dayjs(item.createdAt).format('YYYY-MM-DD HH:mm:ss'),
        }))
);

const filteredDevices = computed(() => dialog.partner.isOpened && appStore.devices.filter(device => {
  const searchWord = dialog.device.searchWord.trim().toUpperCase();
  if (!searchWord) return true;
  return device.name.trim().toUpperCase().includes(searchWord);
}) || []);

// onMounted(async () => {
//   await loadItems();
// });

const loadItems = async () => {
  try {
    const response = apiResponse(await axios.get(`/api/user`));
    if (!response || 0 !== response.code) return;

    content.items = response.response;

  } catch (error) {
    console.log(error);
  }
};

const apiResponse = response => {
  if (200 !== response.status) return;
  return response.data;
};

const onPartner = async partner => {
  await new Promise(r => {
    dialog.partner = {
      isOpened: true,
      id: '', account: '', password: '', repassword: '', name: '', repr: '',
      telegramChatId: '', pendingTelegramChatId: INVALID_TELEGRAM_CHAT_ID,
      devices: [],
      ...JSON.parse(JSON.stringify(partner)),
      onClose: () => r(),
      onSave: async () => await savePartner() && r(),
    };
  });
  dialog.partner.isOpened = false;
};

const savePartner = async () => {
  const id = dialog.partner.id;
  const account = dialog.partner.account.trim();
  const password = dialog.partner.password;
  const repassword = dialog.partner.repassword;
  const name = dialog.partner.name.trim();
  const repr = dialog.partner.repr.trim();
  const telegramChatId = dialog.partner.telegramChatId;
  const devices = dialog.partner.devices.map(({id}) => ({id}));

  if (!id) {
    // 생성
    if (0 === name.length) return alert('가맹점명을 입력하세요.');
    if (0 === account.length) return alert('계정을 입력하세요.');
    if (0 === password.length) return alert('비밀번호를 입력하세요.');
    if (password !== repassword) return alert('비밀번호가 동일하지 않습니다.');

    try {
      const response = apiResponse(await axios.post(`/api/auth/signup`, {
        account, password, name, repr, telegramChatId, devices
      }));
      if (!response || 0 !== response.code) return;

    } catch (error) {
      console.log(error);
    }

  } else {
    // 수정
    if (password !== repassword) return alert('비밀번호가 동일하지 않습니다.');
    if (0 === name.length) return alert('가맹점명을 입력하세요.');

    try {
      const response = apiResponse(await axios.post(`/api/user/${id}`, {
        ...password && {password},
        name, repr, telegramChatId, devices
      }));
      if (!response || 0 !== response.code) return;

    } catch (error) {
      console.log(error);
    }
  }

  await loadItems();

  return true;
};

const onAddDevices = () => {
  (async () => {
    if (!dialog.partner.isOpened) return;

    const done = await new Promise(r => dialog.device = {
      isOpened: true,
      searchWord: '',
      selected: dialog.partner.devices.map(({id}) => id),
      onOk: () => r(true),
      onCancel: () => r(false),
    });
    dialog.device.isOpened = false;
    if (!done) return;

    const selectedItems = appStore.devices.filter(({id}) => dialog.device.selected.includes(id))
    const trimmedItems = selectedItems.filter(({id}) => dialog.partner.devices.every(device => device.id !== id));
    dialog.partner.devices = [...dialog.partner.devices, ...trimmedItems];
  })();
};

const onDeleteDevice = device => {
  (async () => {
    // const operate = confirm('장치를 해제하시겠습니까?');
    // if (!operate) return;
    dialog.partner.devices = dialog.partner.devices.filter(({id}) => id !== device.id);
  })();
};

const onDevice = device => {
  if (dialog.device.selected.includes(device.id))
    dialog.device.selected = dialog.device.selected.filter(id => id !== device.id);
  else
    dialog.device.selected = [...dialog.device.selected, device.id];
};

const onChangeTelegramChatId = async () => {
  const pendingTelegramChatId = dialog.partner.pendingTelegramChatId &&
      dialog.partner.pendingTelegramChatId instanceof Object &&
      dialog.partner.pendingTelegramChatId.id ||
      dialog.partner.pendingTelegramChatId;
  const isDigit = /^-?\d*$/.test(pendingTelegramChatId);
  if (pendingTelegramChatId === null || isDigit)
    dialog.partner.telegramChatId = pendingTelegramChatId;
  else
    alert(`채팅아이디를 저장할 수 없습니다. ${pendingTelegramChatId}`);
  dialog.partner.pendingTelegramChatId = INVALID_TELEGRAM_CHAT_ID;
}

</script>

<style scoped>
.container {position: relative;height: 100vh;overflow: hidden;}
.partner-list {overflow-x: hidden;overflow-y: auto;}
.partner-list tr.selected-row td {background-color: #BDBDBD;}
.partner-list td {white-space: nowrap;text-overflow: ellipsis;overflow: hidden;}
.partner-list td:nth-child(3) {max-width: 200px;}
.device-list {height: 400px;overflow-x: hidden;overflow-y: auto;}
.device-list .selected-row {background-color: #BDBDBD;}
.partner-dialog {max-width: 600px;}
.device-dialog {max-width: 600px;}
.telegram-dialog {max-width: 600px;}

.dialog >>> .v-text-field .v-field--variant-outlined .v-field__input,
.dialog >>> .v-combobox .v-field--variant-outlined .v-field__input {
  min-height: 28px;
  padding: 0 5px;
}
</style>
